import { PROMOCODE_FORM_TYPE } from '../../../../shops/features/promocodes/service/promocodes.interface';

export interface ShopDetailsProps {
    owner: string;
    shop_name: string;
    created_at: Date;
    type: number;
    shop_id: number;
    is_custom: boolean;
}

export interface ShopDetailsFiltersProps {
    readonly limit: number;
    readonly offset: number;
    readonly page: number;
}

export interface ShopDetailsRequest {
    filters: ShopDetailsFiltersProps;
}

export const SHOP_DETAIL_KEY = {
    CUSTOMIZATION: 'customization',
    STYLES: 'styles',
    ANALYTICS: 'analytics',
    DOCUMENTS: 'documents',
};

export type ShopDetailTabKey =
    (typeof SHOP_DETAIL_KEY)[keyof typeof SHOP_DETAIL_KEY];

export interface ShopDetailTabs {
    label: string;
    key: ShopDetailTabKey;
}
